import { Module } from "wrapper6";
import $ from 'jquery';

export default class ScrollTo extends Module {
    ready() {
        let elems = document.getElementsByClassName('scrollto')

        for (let i = 0;i < elems.length;i++){
            let elem = elems[i];
            const href = elem.getAttribute('href')

            if (href.indexOf('#') === 0) {
                elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    $('html, body').animate({
                        scrollTop: $(href).offset().top - 190
                    }, 'normal');
                    window.location.hash = $(elem).attr('href');
                });
            }
        }

        /**
         * Scroll after changing link
         */
        var hash = window.location.hash

        if ( hash == '' || hash == '#' || hash == undefined) {
            return false
        } else if (getQueryVariable('no-scroll')) {
            var target = $(hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');            

            if (target.length) {
                setTimeout(() => {
                    $(document).scrollTop( target.offset().top - 190 );
                }, 1);
            }
            
        } else {
            var target = $(hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            
            if (target.length) {
                $('html,body').stop().animate({
                    scrollTop: target.offset().top - 190
                }, 'normal');
            }
        }
    }
}

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return(false);
}